var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"spinner w-100"}):_vm._e(),_c('Chart',{ref:"chart",attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.series,"height":"800"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }